
import Vue from 'vue'
export default Vue.extend({
  props: { code: { type: String, default: '' } },
  computed: { introUrl(): string {
    const origin = process.env.VUE_APP_NAMECARD_WORKSPACE_URL || window.location.origin
    return new URL('/intro?src=limit', origin).toString()
  } }
})
